<template>
  <div>
    <div class="right floated content">
      <i class="new-item el-icon-document-add"></i>
      <svg-icon icon-class="new1"/>
    </div>
    <div class="content">
      <div class="header">{{header}}</div>
      <div class="description">{{description}}</div>
    </div>
  </div>
</template>

<script>
import getField from '@/utils/getField'

export default {
  name: 'ListItem',
  props: {
    item: Object,
    itemRenderOptions: Object
  },
  computed: {
    header () {
      return getField(this.item, this.itemRenderOptions.headerField)
    },
    description () {
      return getField(this.item, this.itemRenderOptions.descriptionField)
    }
  }
}
</script>

<style scoped>
  .item .content {
    color: #37485b;
    padding-left: 1rem;
  }
  .item .description {
    padding-top: 0.4rem;
    color: #979b9f !important;
    font-size: 0.8rem;
  }
  .item .right.floated.content {
    margin-right: 1rem;
    display: none;
  }
  .item.modified .right.floated.content,
  .item.new-item .right.floated.content {
    display: block;
  }
  .right.floated.content .modified,
  .right.floated.content .new-item {
    display: none;
  }
  .item.modified .right.floated.content .modified,
  .item.new-item .right.floated.content .new-item {
    display: inline-block;
  }
</style>



// WEBPACK FOOTER //
// src/components/layout/List/ListItem.vue